module.exports = __webpack_public_path__ + "img/wisdom_12.531c56bc.svg";